import React, { useReducer, createContext } from 'react';
import { REQUEST_SUBMITTED, SET_HISTOGRAM_DATA, API_ERROR,  SET_SUMMARY_DATA_FA, SET_TREND_DATA, SET_SUMMARY_DATA_LA, SET_ASIN_DATA} from '../actions/actionTypes';
import { extractErrorMessage } from '../../../utilities.js';
import logger from '../../../utils/logging.js';

const initialState = {
  requestSubmitted: false,
  request: null,
  histogramData: null,
  summaryDataFA: [],
  summaryDataLA: [],
  trendData: null,
  asinData: null,
  flashbarItem: null,
  flashbarIdCount: 0,
};

export const StateContext = createContext(initialState);
export const DispatchContext = createContext(null);

// TODO: move reducer to separater folder
const reducer = (state, action) => {
  switch (action.type) {
    case REQUEST_SUBMITTED:
      return { ...state, requestSubmitted: true, request: action.payload, histogramData: null, summaryDataFA: null, summaryDataLA: null, trendData: null };
    case SET_HISTOGRAM_DATA:
      return { ...state, histogramData: { ...state.histogramData, ...action.payload } };
    case SET_SUMMARY_DATA_FA:
      return { ...state, summaryDataFA: action.payload};
    case SET_SUMMARY_DATA_LA:
      return { ...state, summaryDataLA: action.payload};
    case SET_TREND_DATA:
      return { ...state, trendData: {...state.trendData, ...action.payload} };
    case SET_ASIN_DATA:
      return {...state, asinData: action.payload};
    case API_ERROR:
      const { error, api } = action.payload;
      const errorMessage = extractErrorMessage(error);
      logger.error(`call API ${api} failed with message: ${errorMessage}`, error);

      const { flashbarIdCount } = state;
      const newId = flashbarIdCount + 1;
      const newItem = {
        header: `An error happened when calling API: ${api}. Please try again`,
        type: 'error',
        content: `${errorMessage}`,
        dismissible: true,
        // the onDismiss function needs to be define in contents.jsx
        id: newId,
      };
      return { ...state, flashbarIdCount: newId, flashbarItem: newItem };
    default:
      return state;
  }
};

export const SpotcpContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <DispatchContext.Provider value={dispatch}>
      <StateContext.Provider value={state}>{props.children}</StateContext.Provider>
    </DispatchContext.Provider>
  );
};


// WEBPACK FOOTER //
// ./src/components/spotcp/context/spotcp-context.jsx